<template>
  <aside class="pd-sb">
    <div class="pd-sb__scroll">

      <!-- ── Brand ─────────────────────────────────────────────────────── -->
      <div class="pd-sb__brand">
        <div class="pd-sb__brand-logo">
          <img src="/static/logoSunDrive.png" alt="SunExpert Logo" style="width: 100%; height: 100%; object-fit: contain;">
        </div>
        <div>
          <h2 class="pd-sb__brand-title">SunExpert</h2>
          <p class="pd-sb__brand-sub">Supply Chain Dept.</p>
        </div>
        <button class="pd-sb__close-btn" @click="$emit('close-sidebar')">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>

      <!-- ── Navegación ─────────────────────────────────────────────────── -->
      <div class="pd-sb__section">
        <span class="pd-sb__section-label">Página</span>
        <button
          v-if="$fun.hasSpecialPermission('viewDashboardSummary')"
          class="pd-sb__nav-btn"
          :class="{ 'pd-sb__nav-btn--active': activeTab === 'resumen' }"
          @click="$emit('tab-changed', 'resumen')"
        >
          <i class="fa-solid fa-chart-pie"></i>
          <span>1. Resumen OC</span>
        </button>
        <button
          v-if="$fun.hasSpecialPermission('viewDashboardSummary')"
          class="pd-sb__nav-btn"
          :class="{ 'pd-sb__nav-btn--active': activeTab === 'gestion' }"
          @click="$emit('tab-changed', 'gestion')"
        >
          <i class="fa-solid fa-gauge-high"></i>
          <span>2. Gestión y Cumplimiento</span>
        </button>
        <button
          v-if="$fun.hasSpecialPermission('viewDashboardHistory')"
          class="pd-sb__nav-btn"
          :class="{ 'pd-sb__nav-btn--active': activeTab === 'historico' }"
          @click="$emit('tab-changed', 'historico')"
        >
          <i class="fa-solid fa-chart-line"></i>
          <span>3. Histórico Precios</span>
        </button>
        <button
          v-if="$fun.hasSpecialPermission('viewDashboardReceipt')"
          class="pd-sb__nav-btn"
          :class="{ 'pd-sb__nav-btn--active': activeTab === 'ingreso' }"
          @click="$emit('tab-changed', 'ingreso')"
        >
          <i class="fa-solid" :class="String(filters.OrderType) === '3' ? 'fa-handshake' : 'fa-boxes-stacked'"></i>
          <span>4. {{ String(filters.OrderType) === '3' ? 'Ejecución de Servicios' : 'Ingreso de Materiales' }}</span>
        </button>
      </div>

      <!-- ── Filtros ────────────────────────────────────────────────────── -->
      <div class="pd-sb__section pd-sb__section--border">
        <span class="pd-sb__section-label">Filtros Generales</span>

        <div class="pd-sb__filter">
          <label class="pd-sb__filter-label">Tipo Orden</label>
          <DashboardSelect v-model="filters.OrderType" :options="orderTypeOpts" placeholder="Todos" @change="emitFilters" />
        </div>

        <div class="pd-sb__filter">
          <label class="pd-sb__filter-label">Año</label>
          <DashboardSelect v-model="filters.year" :options="yearOpts" placeholder="Todos los Años" multiple @change="emitFilters" />
        </div>

        <div class="pd-sb__filter">
          <label class="pd-sb__filter-label">Mes</label>
          <DashboardSelect v-model="filters.month" :options="monthOpts" placeholder="Todos los Meses" multiple @change="emitFilters" />
        </div>

        <div class="pd-sb__filter">
          <label class="pd-sb__filter-label">Proveedor</label>
          <DashboardSupplier v-model="filters.SupCode" multiple @change="emitFilters" />
        </div>

        <div class="pd-sb__filter">
          <label class="pd-sb__filter-label">Rubro (Packaging)</label>
          <DashboardSelect v-model="filters.CategoryCode" :options="categoryOpts" placeholder="Todos los Rubros" multiple @change="emitFilters" />
        </div>

        <div v-show="activeTab === 'resumen'" class="pd-sb__filter">
          <label class="pd-sb__filter-label">Comprador</label>
          <DashboardSelect v-model="filters.ShopperID" :options="shopperOpts" placeholder="Todos los Compradores" multiple @change="emitFilters" />
        </div>

        <div v-show="activeTab === 'resumen'" class="pd-sb__filter">
          <label class="pd-sb__filter-label">Estado OC</label>
          <DashboardDefinition v-model="filters.OrdStatus" :def="1151" placeholder="Todos los Estados" multiple @change="emitFilters" />
        </div>
        
      </div>
    </div>

    <!-- ── Footer sidebar ──────────────────────────────────────────────── -->
    <div class="pd-sb__footer">
      <div class="pd-user-profile" v-if="userInfo" @click="showUserMenu = !showUserMenu" style="position: relative; cursor: pointer;">
        <div class="pd-user-avatar">
          <img v-if="userImage" :src="userImage" alt="Avatar" />
          <div v-else class="pd-user-initials">{{ userInitials }}</div>
        </div>
        <div class="pd-user-info">
          <p class="pd-user-name">{{ userInfo.NtpName }} {{ userInfo.NtpPaternalSurname }}</p>
          <p class="pd-user-role">{{ userInfo.PrsMail || (userInfo.CtrContract ? userInfo.CtrContract.PstName : 'Logística') }}</p>
        </div>
        <i class="fa-solid fa-ellipsis-vertical pd-user-more"></i>
        
        <!-- Menú desplegable de usuario -->
        <div v-if="showUserMenu" class="pd-user-menu" @click.stop>
          <button @click="goToHome">
            <i class="fa-solid fa-arrow-right-from-bracket"></i> Salir a SunExpert
          </button>
        </div>
      </div>
    </div>
  </aside>
</template>

<script>
import DashboardSelect from './DashboardSelect.vue';
import DashboardSupplier from './DashboardSupplier.vue';
import DashboardDefinition from './DashboardDefinition.vue';
import _sOrderPurchase from '@/services/Logistics/OrderPurchaseService';

export default {
  name: 'DashboardSidebar',
  components: { DashboardSelect, DashboardSupplier, DashboardDefinition },
  props: {
    dataset:   { type: Array,  default: () => [] },
    activeTab: { type: String, default: 'resumen' },
  },
  data() {
    return {
      filters: { 
        OrderType: 1,
        year: String(new Date().getFullYear()), 
        month: null, 
        SupCode: null, 
        CategoryCode: null, 
        ShopperID: null, 
        OrdStatus: null
      },
      suppliers: [],
      categoriesList: [],
      shoppersList: [],
      userInfo: null,
      orderTypeOpts: [
        { value: 1, label: 'Artículo' },
        { value: 3, label: 'Servicio' }
      ],
      userImage: null,
      showUserMenu: false,
      monthOptions: [
        { value: '01', label: 'Enero' },
        { value: '02', label: 'Febrero' },
        { value: '03', label: 'Marzo' },
        { value: '04', label: 'Abril' },
        { value: '05', label: 'Mayo' },
        { value: '06', label: 'Junio' },
        { value: '07', label: 'Julio' },
        { value: '08', label: 'Agosto' },
        { value: '09', label: 'Septiembre' },
        { value: '10', label: 'Octubre' },
        { value: '11', label: 'Noviembre' },
        { value: '12', label: 'Diciembre' },
      ],
    };
  },
  computed: {
    yearOpts() {
      const current = new Date().getFullYear();
      const years = [];
      for (let y = current; y >= 2010; y--) years.push({ value: String(y), label: String(y) });
      return years;
    },
    monthOpts() {
      return this.monthOptions;
    },
    categoryOpts() {
      const opts = [];
      this.categoriesList.forEach(r => {
        const valueCode = r.code || r.Code;
        const labelName = r.name || r.Name || valueCode;
        if (valueCode) {
          opts.push({ value: valueCode, label: labelName });
        }
      });
      return opts;
    },
    shopperOpts() {
      const opts = [];
      this.shoppersList.forEach(c => {
        const valueId = c.usrID || c.UsrID;
        const name = c.ntpName || c.NtpName;
        if (valueId) {
          opts.push({ value: valueId, label: name });
        }
      });
      return opts;
    },
    userInitials() {
      if (!this.userInfo) return 'U';
      const n = this.userInfo.NtpName ? this.userInfo.NtpName.charAt(0) : '';
      const p = this.userInfo.NtpPaternalSurname ? this.userInfo.NtpPaternalSurname.charAt(0) : '';
      return (n + p).toUpperCase();
    }
  },
  mounted() {
    this.emitFilters();
    this.fetchCategories();
    this.fetchShoppers();
    this.fetchUser();
  },
  watch: {
    dataset: {
      immediate: true,
      handler(data) {
        const provs = new Set(), skusMap = new Map();
        (data || []).forEach(r => {
          if (r.SupName)       provs.add(r.SupName);
          if (r.ItemCode) skusMap.set(r.ItemCode, r.ItemDescription);
        });
        this.suppliers  = Array.from(provs).sort();
        this.skus       = Array.from(skusMap.keys()).sort().map(id => ({ id, name: skusMap.get(id) }));
        if (this.skus.length && this.filters.sku === 'ALL') {
          this.filters.sku = this.skus[0].id;
          this.emitFilters();
        }
      },
    },
  },
  methods: {
    async fetchCategories() {
      try {
        const res = await _sOrderPurchase.getCategory();
        if (res && res.data) {
          this.categoriesList = res.data;
        }
      } catch (error) {
        console.error("Error al obtener categorias:", error);
      }
    },
    async fetchShoppers() {
      try {
        const res = await _sOrderPurchase.getShopper();
        if (res && res.data) {
          this.shoppersList = res.data;
        }
      } catch (error) {
        console.error("Error al obtener compradores:", error);
      }
    },
    async fetchUser() {
      try {
        this.userInfo = this.$fun.getUserInfo();
        if (!this.userInfo || !this.userInfo.PrsDocumentNumber) return;
        const _sHelper = require('@/services/HelperService').default;
        const rsp = await _sHelper.getPhotoWorkerBase64(this.userInfo.PrsDocumentNumber, this.$fun.getUserID());
        if (rsp && rsp.status === 200 && rsp.data) {
          this.userImage = "data:image/jpg;base64," + rsp.data;
        }
      } catch (err) {
        console.error("Error cargando foto de perfil:", err);
      }
    },
    goToHome() {
      this.$router.replace("/");
    },
    emitFilters() { this.$emit('filter-changed', this.filters); }
  },
};
</script>

<style scoped>
.pd-sb {
  display: flex !important;
  flex-direction: column !important;
  width: 256px !important;
  min-width: 256px !important;
  height: 100% !important;
  background: var(--pd-sidebar-bg, #FFFFFF) !important;
  border-right: 1px solid var(--pd-border, #E2E8F0) !important;
  overflow: hidden !important;
}
.pd-sb__scroll { flex: 1 !important; overflow-y: auto !important; display: flex !important; flex-direction: column !important; }

/* Brand */
.pd-sb__brand {
  display: flex !important;
  align-items: center !important;
  gap: 12px !important;
  padding: 20px 20px 16px !important;
  border-bottom: 1px solid rgba(226, 232, 240, 0.6) !important;
  position: relative !important;
}
.pd-sb__brand-logo {
  width: 45px !important; height: auto !important; flex-shrink: 0 !important;
  display: flex !important; align-items: center !important; justify-content: center !important;
}
.pd-sb__brand-logo i { color: #fff !important; font-size: 16px !important; }
.pd-sb__brand-title  { font-size: 18px !important; font-weight: 800 !important; color: #0A5C36 !important; letter-spacing: -0.4px !important; }
.pd-sb__brand-sub    { font-size: 9px !important;  font-weight: 600 !important; color: #94A3B8 !important; text-transform: uppercase !important; letter-spacing: 0.8px !important; margin-top: 1px !important; }
.pd-sb__close-btn    { display: none !important; margin-left: auto !important; background: none !important; border: none !important; cursor: pointer !important; color: #94A3B8 !important; font-size: 18px !important; padding: 4px !important; }
@media (max-width: 1023px) { .pd-sb__close-btn { display: flex !important; } }

/* Sección */
.pd-sb__section { padding: 14px 14px 8px !important; display: flex !important; flex-direction: column !important; gap: 4px !important; }
.pd-sb__section--border { border-top: 1px solid rgba(226, 232, 240, 0.6) !important; gap: 10px !important; }
.pd-sb__section-label { font-size: 9px !important; font-weight: 700 !important; color: #94A3B8 !important; text-transform: uppercase !important; letter-spacing: 1.5px !important; padding: 0 6px !important; margin-bottom: 4px !important; display: block !important; }

/* Nav buttons */
.pd-sb__nav-btn {
  display: flex !important; align-items: center !important; gap: 10px !important;
  width: 100% !important; padding: 10px 14px !important;
  border-radius: 10px !important; border: none !important; cursor: pointer !important;
  font-size: 12px !important; font-weight: 600 !important;
  background: transparent !important; color: #475569 !important;
  transition: all .15s ease !important;
  text-align: left !important;
  font-family: 'Inter', sans-serif !important;
}
.pd-sb__nav-btn:hover { background: rgba(203,213,225,.4) !important; color: #1E293B !important; }
.pd-sb__nav-btn--active {
  background: #0A5C36 !important;
  color: #fff !important;
  box-shadow: 0 2px 8px rgba(10,92,54,.2) !important;
}
.pd-sb__nav-btn--active:hover { background: #074226 !important; color: #fff !important; }
.pd-sb__nav-btn i { font-size: 13px !important; width: 16px !important; text-align: center !important; }

/* Filters */
.pd-sb__filter { display: flex !important; flex-direction: column !important; gap: 4px !important; }
.pd-sb__filter-label { font-size: 9px !important; font-weight: 700 !important; color: #64748B !important; text-transform: uppercase !important; letter-spacing: .8px !important; padding-left: 2px !important; }
.pd-sb__select {
  width: 100% !important; padding: 7px 10px !important;
  background: #fff !important;
  border: 1px solid #E2E8F0 !important;
  border-radius: 8px !important;
  font-size: 11px !important; color: #334155 !important;
  outline: none !important;
  appearance: auto !important;
  -webkit-appearance: auto !important;
  transition: border-color .15s !important;
  font-family: 'Inter', sans-serif !important;
}
.pd-sb__select:focus { border-color: #0A5C36 !important; box-shadow: 0 0 0 2px rgba(10,92,54,.12) !important; }

/* Footer */
.pd-sb__footer {
  padding: 12px 14px !important;
  border-top: 1px solid var(--pd-border, #E2E8F0) !important;
  background: transparent !important;
  display: flex !important; flex-direction: column !important;
}

/* User Profile Block (Shadcn style) */
.pd-user-profile {
  display: flex !important;
  align-items: center !important;
  gap: 12px !important;
  padding: 8px 12px !important;
  background: transparent !important;
  border: none !important;
  border-radius: 8px !important;
  cursor: pointer !important;
  transition: background 0.15s ease !important;
  position: relative !important;
}
.pd-user-profile:hover {
  background: rgba(0,0,0,0.05) !important;
}

.pd-user-avatar {
  width: 36px !important;
  height: 36px !important;
  border-radius: 8px !important;
  overflow: hidden !important;
  flex-shrink: 0 !important;
  background: var(--pd-border, #E2E8F0) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  border: none !important;
}

.pd-user-avatar img {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
}

.pd-user-initials {
  font-size: 13px !important;
  font-weight: 600 !important;
  color: var(--pd-text, #1E293B) !important;
}

.pd-user-info {
  display: flex !important;
  flex-direction: column !important;
  gap: 2px !important;
  flex: 1 !important;
  overflow: hidden !important;
}

.pd-user-name {
  font-size: 13px !important;
  font-weight: 600 !important;
  color: var(--pd-text, #1E293B) !important;
  margin: 0 !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.pd-user-role {
  font-size: 11px !important;
  font-weight: 400 !important;
  color: var(--pd-text-muted, #64748B) !important;
  margin: 0 !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.pd-user-more {
  font-size: 14px !important;
  color: var(--pd-text-muted, #94A3B8) !important;
  margin-left: auto !important;
}

.pd-sb__update-time { 
  font-size: 9px !important; 
  color: #94A3B8 !important; 
  text-align: center !important; 
  font-weight: 600 !important; 
  margin: 0 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
}
.pd-sb__update-time i {
  margin-right: 4px !important;
}

/* Menu desplegable perfil */
.pd-user-menu {
  position: absolute !important;
  bottom: calc(100% + 8px) !important;
  left: 0 !important;
  right: auto !important;
  background: var(--pd-white, #fff) !important;
  border: 1px solid var(--pd-border, #E2E8F0) !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1) !important;
  padding: 6px !important;
  min-width: 180px !important;
  z-index: 100 !important;
}
.pd-user-menu button {
  width: 100% !important;
  text-align: left !important;
  padding: 10px 12px !important;
  background: none !important;
  border: none !important;
  border-radius: 6px !important;
  font-size: 12px !important;
  color: #EF4444 !important; /* Rojo */
  cursor: pointer !important;
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  font-weight: 600 !important;
  transition: background 0.2s !important;
}
.pd-user-menu button:hover {
  background: #FEF2F2 !important;
}

#packaging-dashboard.pd--dark .pd-user-menu {
  background: #1E293B !important;
  border-color: #334155 !important;
}
#packaging-dashboard.pd--dark .pd-user-menu button:hover {
  background: rgba(239, 68, 68, 0.1) !important;
}
</style>
